import { formatOrderDate, formatOrderTime, parseDateTime } from "../orders/format";

const DAY_MS = 24 * 60 * 60 * 1000;

const startOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

export const calendarDaysAgo = (date, now = new Date()) =>
  Math.round((startOfDay(now) - startOfDay(date)) / DAY_MS);

export const sectionTitle = (date, now = new Date()) => {
  if (!date) return "Earlier";

  const days = calendarDaysAgo(date, now);

  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return "This week";

  return formatOrderDate(date);
};

export const stampLabel = (date, now = new Date()) => {
  if (!date) return "";

  const days = calendarDaysAgo(date, now);

  if (days <= 0) {
    const minutes = Math.floor((now.getTime() - date.getTime()) / 60000);

    if (minutes < 1) return "Just now";
    if (minutes < 60) return `${minutes}m ago`;

    return `${Math.floor(minutes / 60)}h ago`;
  }

  if (days === 1) return "Yesterday";
  if (days < 7) return `${days}d ago`;

  return `${formatOrderDate(date)} | ${formatOrderTime(date)}`;
};

export const toDate = (value) => parseDateTime(value);
